document.addEventListener("DOMContentLoaded", function () {
    const cookiesBlock = document.querySelector(".cookies-consent");
    const cookieName = 'consent';

    let cookie = document.cookie.split('; ').find(row => row.startsWith(cookieName + '='));

    if (cookie && cookiesBlock) {
        cookiesBlock.style.display = "none";
        return;
    } else {
        cookiesBlock.classList.add("active");
    }
    const btn = cookiesBlock?.querySelector(".cookies-consent-btn");
    if (btn) {
        btn.addEventListener("click", () => {
            document.cookie = `${cookieName}=true; path=/; max-age=${60 * 60 * 24 * 30}`;
            cookiesBlock.classList.remove("active");
            setTimeout(() =>{
                cookiesBlock.style.display = "none";
            }, 1000);
        });
    }
});